
var GROUP_INFO = {
  OCR_ORG: {
    GROUP_ID: "OCR_ORG_INFO_PAGE",
    IMP_OCR: {
      MODULE_ID: "IMPORTANT_MODULE_OCR",
      SAVE_PATH: ""
    },
    IMP_ZD: {
      MODULE_ID: "IMPORTANT_MODULE_ZD",
      SAVE_PATH: "BIZ_DATA.ZD_INFO"
    },
    ZD: {
      MODULE_ID: "ZD_MODULE",

      SAVE_PATH: "BIZ_DATA.KEY_INFO"
    },
    IMP: {
      MODULE_ID: "IMPORTANT_MODULE",

      SAVE_PATH: "BIZ_DATA.MANAGER_INFO",
      SAVE_PATH2: "BIZ_DATA.BASE_INFO",
      SAVE_PATH3: "BIZ_DATA.EXT_INFO"
    }
  },
  OCR_AGENT: {
    GROUP_ID: "OCR_AGENT_INFO_PAGE",
    AGENT_OCR: {
      MODULE_ID: "AGENT_MODULE_OCR",
      SAVE_PATH: ""
    },

    AGENT: {
      MODULE_ID: "AGENT_MODULE",
      SAVE_PATH: "BIZ_DATA.AGENT_INFO"
    }
  },
  PRO: {
    GROUP_ID: "PRODUCT_INFO_PAGE",
    BASE: {
      MODULE_ID: "BASE_INFO",
      SAVE_PATH: "BIZ_DATA.PRODUCT_INFO"
    }
  },
  MANAGER: {
    GROUP_ID: "MANAGER_INFO_PAGE",
    OTHER: {
      MODULE_ID: "MANAGER_OTHER_INFO",
      SAVE_PATH: "BIZ_DATA.BASE_INFO",
      SAVE_PATH2: "BIZ_DATA.CONTACT_INFO",
      SAVE_PATH3: "BIZ_DATA.EXT_INFO",
      SAVE_PATH4: "BIZ_DATA.PRODUCT_INFO"
    }
  },
  OTHER: {
    GROUP_ID: "OTHER_INFO_PAGE",
    LINK: {
      MODULE_ID: "LINK_MODULE",

      SAVE_PATH: "BIZ_DATA.CONTACT_INFO",
      SAVE_PATH2: "BIZ_DATA.LINKMAN_INFO_LIST",
      SAVE_PATH3: "DETAIL_DATA.CONTACT_INFO"
    },
    LEGAL: {
      MODULE_ID: "LEGAL_MODULE",

      SAVE_PATH: "BIZ_DATA.LEGAL_REP_INFO",
      SAVE_PATH2: "DETAIL_DATA.CONTACT_INFO"
    },
    AGENT_LINK: {
      MODULE_ID: "AGENT_LINK_MODULE",

      SAVE_PATH: "BIZ_DATA.AGENT_INFO"
    },
    PARTNER: {
      MODULE_ID: "PARTNER_MODULE",
      SAVE_PATH: "BIZ_DATA.PARTNER_INFO_LIST"
    },
    OTHER_INFO: {
      SAVE_PATH: "BIZ_DATA.PRO_TRUSTEE_INFO",

      SAVE_PATH2: "BIZ_DATA.PRO_ORD_INFO",

      SAVE_PATH3: "BIZ_DATA.INVEST_INFO",

      SAVE_PATH4: "BIZ_DATA.SHAREREG_ORG_INFO"
    }
  },
  CONTROLER: {
    GROUP_ID: "CONTROLER_INFO_PAGE",
    CTRMODULE1: {
      MODULE_ID: "CONTROLER_MODULE1",

      SAVE_PATH: "BIZ_DATA.CONTROLLER_SOTCK_INFO_LIST"
    },
    CTRMODULE: {
      MODULE_ID: "CONTROLER_MODULE",

      SAVE_PATH: "BIZ_DATA.CONTROLLER_INFO_LIST"
    },
    CTRMODULE2: {
      MODULE_ID: "CONTROLER_MODULE2",
      SAVE_PATH: "BIZ_DATA.CONTROLLER_ACTUAL_INFO_LIST"
    },
    BENEFICIARY: {
      MODULE_ID: "BENEFICIARY_MODULE",

      SAVE_PATH: "BIZ_DATA.BENEFICIARY_MODULE",
      SAVE_PATH2: "DETAIL_DATA.BENEFICIARY_MODULE"
    },
    BENEFICIARY_1: {
      MODULE_ID: "BENEFICIARY_MODULE_1",

      SAVE_PATH: "BIZ_DATA.BENEFICIARY_MODULE_1",
      SAVE_PATH2: "DETAIL_DATA.BENEFICIARY_MODULE_1"
    },
    BENEFICIARY_0: {
      MODULE_ID: "BENEFICIARY_MODULE_0",

      SAVE_PATH: "BIZ_DATA.BENEFICIARY_MODULE_0",
      SAVE_PATH2: "DETAIL_DATA.BENEFICIARY_MODULE_0"
    },
    BENEFICIARY_2: {
      MODULE_ID: "BENEFICIARY_MODULE_2",

      SAVE_PATH: "BIZ_DATA.BENEFICIARY_MODULE_2",
      SAVE_PATH2: "DETAIL_DATA.BENEFICIARY_MODULE_2"
    },
    BENEFICIARY_3: {
      MODULE_ID: "BENEFICIARY_MODULE_3",

      SAVE_PATH: "BIZ_DATA.BENEFICIARY_MODULE_3",
      SAVE_PATH2: "DETAIL_DATA.BENEFICIARY_MODULE_3"
    },
    BENEFICIARY_4: {
      MODULE_ID: "BENEFICIARY_MODULE_4",

      SAVE_PATH: "BIZ_DATA.BENEFICIARY_MODULE_4",
      SAVE_PATH2: "DETAIL_DATA.BENEFICIARY_MODULE_4"
    }
  },
  TAX: {
    GROUP_ID: "TAX_INFO",
    CUST_INFO: {
      MODULE_ID: "MA_CUST_TAX_INFO_MODULE",

      SAVE_PATH: "BIZ_DATA.CUST_TAX_INFO"
    },
    CONTROLER_TAX: {
      MODULE_ID: "MA_CONTROLER_TAX_INFO_MODULE",

      SAVE_PATH: "BIZ_DATA.CONTROLLER_TAX_INFO_LIST"
    },
    CREDIT_INFO: {
      MODULE_ID: "CREDIT_INFO",
      SAVE_PATH: "BIZ_DATA.CREDIT_INFO_LIST"
    }
  },
  ACCT: {
    GROUP_ID: "ACCT_INFO",
    TRDACCT_INFO: {
      MODULE_ID: "TRDACCT_MODULE",

      SAVE_PATH: "BIZ_DATA.TRDACCT_INFO_LIST"
    },
    BSB_INFO: {
      MODULE_ID: "BSB_MODULE",

      SAVE_PATH: "BIZ_DATA.BSB_INFO",
      SAVE_PATH2: "DETAIL_DATA.BSB_INFO"
    },
    ASSET_INFO: {
      MODULE_ID: "ASSET_MODULE",

      SAVE_PATH: "BIZ_DATA.BANK_ACCT_INFO_LIST",
      SAVE_PATH2: "BIZ_DATA.CUACCT_INFO_LIST" }
  },
  PASSWORD: {
    GROUP_ID: "PASSWORD_INFO",
    AGENT_PHONE_INFO: {
      MODULE_ID: "AGENT_PHONE_MODULE",

      SAVE_PATH: "BIZ_DATA.AGENT_INFO",
      SAVE_PATH2: "DETAIL_DATA.AGENT_INFO"
    },
    PASSWORD_INFO: {
      MODULE_ID: "PASSWORD_MODULE",

      SAVE_PATH: "BIZ_DATA.ACCT_PWD_INFO",
      SAVE_PATH2: "DETAIL_DATA.ACCT_PWD_INFO"
    }
  }
};

export default GROUP_INFO;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/QS421_groupInfo.js
// module id = 160
// module chunks = 2